import { Component, ViewEncapsulation, Input, OnInit, OnDestroy } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { IAppState } from '@app/store';
import { Subscription } from 'rxjs';
import { Order, OrderLine } from '@vestiaire/api-sdk-angular';
import { CheckoutService } from '@app/shared/services/checkout/checkout.service';

import * as fromCart from '@app/core/cart/reducers';
import * as cartActions from '@app/core/cart/actions/cart.actions';

@Component({
  selector: 'vc-floating-cart',
  templateUrl: './floating-cart.component.html',
  styleUrls: ['./floating-cart.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FloatingCartComponent implements OnInit, OnDestroy {
  @Input()
  isShow;
  currentCart: Order;
  pending = false;
  useNewCheckout = false;
  newCartUrl = '';
  newCheckoutUrl = '';

  private currentCartSubscription: Subscription;
  private cartPendingSubscription: Subscription;

  constructor(private store$: Store<IAppState>, private checkoutService: CheckoutService) {}

  get hasItems(): boolean {
    return this.currentCart && this.currentCart.itemsNumber > 0;
  }

  ngOnInit() {
    this.cartPendingSubscription = this.store$.pipe(select(fromCart.getCartPending)).subscribe(
      res => (this.pending = res),
      err => (this.pending = false)
    );

    this.currentCartSubscription = this.store$.pipe(select(fromCart.getCurrentCart)).subscribe(
      cart => (this.currentCart = cart),
      err => (this.currentCart = null)
    );

    this.useNewCheckout = this.checkoutService.canAccessNewCheckout();
    if (this.useNewCheckout) {
      this.newCartUrl = this.checkoutService.getCartUrl();
      this.newCheckoutUrl = this.checkoutService.getCheckoutUrl();
    }
  }

  ngOnDestroy(): void {
    this.currentCartSubscription.unsubscribe();
    this.cartPendingSubscription.unsubscribe();
  }

  onRemoveProduct(orderLine: OrderLine): void {
    this.store$.dispatch(new cartActions.RemoveFromCart(orderLine));
  }

  onClosePreviewBox(): void {
    this.isShow = false;
    this.ngOnDestroy();
  }
}
